<template>
  <img src="/ipsafer-logo.png" :style="{ width: 'auto', height: props.height + 'px' }" alt="IPSafer" />
</template>
<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    height?: number
  }>(),
  {
    height: 50,
  },
)
</script>
